import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import Autorizacao, { validaPerfis } from '../../security/Autorizacao';
import {
  getAdminEmpresa, getFinanceiroAgencia, getFinanceiroCaixa,
  getFinanceiroEmpresa,
  getFiscalEmbarque,
  getGestorEmpresa,
  getOperadorEmpresa,
  getVendedorAgencia,
  PERFIL_ADMIN,
} from '../../security/securityContext';
import Titulo from '../comum/Titulo';
import RequestQuoteOutlinedIcon from '@mui/icons-material/RequestQuoteOutlined';
import SignpostOutlinedIcon from '@mui/icons-material/SignpostOutlined';

export class MenuFechamentoCaixa extends Component {

  possuiPerfilFinanceiroAgenciaEVendedorAgencia() {
    return validaPerfis([getFinanceiroAgencia(this.props.empresaSelecionada.id)])
      && validaPerfis([getVendedorAgencia(this.props.empresaSelecionada.id)])
  }

  possuiPerfilVerAdminOuFinaceiroEmpresa() {
    return validaPerfis([PERFIL_ADMIN]) || validaPerfis([getFinanceiroEmpresa(this.props.empresaSelecionada.id)])
  }

  render () {
    return (
      <div className="area-home">
        <Titulo texto="Relatórios" urlRetorno="/"/>
        <div className="row sistemas mt-4">
          <Autorizacao perfisPermitidos={[
            getFinanceiroAgencia(this.props.empresaSelecionada.id),
            getFinanceiroEmpresa(this.props.empresaSelecionada.id),
            getFinanceiroCaixa(this.props.empresaSelecionada.id),
            getAdminEmpresa(this.props.empresaSelecionada.id),
            PERFIL_ADMIN]}
            empresaSelecionada={this.props.empresaSelecionada}>
            <div className="col-6 col-sm-6 col-md-3">
              <Link to="/painel-resumo-financeiro">
                <div className="card card-inicial ">
                    <div className="card card-inicial-interno ">
                      <i className="material-icons custom-icons"><RequestQuoteOutlinedIcon className='css-icon' /></i>
                      <h5 className='nm-longo-resize'>
                        Resumo Financeiro
                      </h5>
                    </div>
                </div>
              </Link>
            </div>
          </Autorizacao>
          <Autorizacao perfisPermitidos={[getOperadorEmpresa(this.props.empresaSelecionada.id),
            getAdminEmpresa(this.props.empresaSelecionada.id),
            getGestorEmpresa(this.props.empresaSelecionada.id),
            getFiscalEmbarque(this.props.empresaSelecionada.id),
            getFinanceiroEmpresa(this.props.empresaSelecionada.id),
            PERFIL_ADMIN]}
            empresaSelecionada={this.props.empresaSelecionada}>
            <div className="col-6 col-sm-6 col-md-3">
              <Link to="/painel-relatorio-itinerarios">
                <div className="card card-inicial ">
                    <div className="card card-inicial-interno ">
                      <i className="material-icons custom-icons"><SignpostOutlinedIcon className='css-icon' /></i>
                      <h5 style={{ fontSize: 14 }}>
                        Itinerários
                      </h5>
                    </div>
                </div>
              </Link>
            </div>
          </Autorizacao>
          <Autorizacao perfisPermitidos={[getFinanceiroEmpresa(this.props.empresaSelecionada.id),
            PERFIL_ADMIN]}
            empresaSelecionada={this.props.empresaSelecionada}>
            <div className="col-6 col-sm-6 col-md-3">
              <Link to="/painel-relatorio-gerencial">
                <div className="card card-inicial ">
                    <div className="card card-inicial-interno ">
                      <i className="material-icons custom-icons"><SignpostOutlinedIcon className='css-icon' /></i>
                      <h5 style={{ fontSize: 14 }}>
                        Relatório Gerencial
                      </h5>
                    </div>
                </div>
              </Link>
            </div>
          </Autorizacao>
          {(this.possuiPerfilFinanceiroAgenciaEVendedorAgencia() || this.possuiPerfilVerAdminOuFinaceiroEmpresa()) && <Autorizacao perfisPermitidos={[getAdminEmpresa(this.props.empresaSelecionada.id),
            getFinanceiroEmpresa(this.props.empresaSelecionada.id),
            getFinanceiroAgencia(this.props.empresaSelecionada.id),
            PERFIL_ADMIN]}
            empresaSelecionada={this.props.empresaSelecionada}>
            <div className="col-6 col-sm-6 col-md-3">
                <Link to="/painel-relatorio-gerencial-agencia">
                  <div className="card card-inicial ">
                      <div className="card card-inicial-interno ">
                        <i className="material-icons custom-icons"><SignpostOutlinedIcon className='css-icon' /></i>
                        <h5 style={{ fontSize: 14, lineHeight: '20px' }}>
                          Relatório Gerencial Agência
                        </h5>
                      </div>
                  </div>
                </Link>
              </div>
          </Autorizacao>}
        </div>
      </div>
    );
  }
}
export function mapStateToProps (state) {
  return {
    empresaSelecionada: state.empresaSelecionada,
    authentication: state.authentication
  }
}



export default withRouter(connect(mapStateToProps, {})(MenuFechamentoCaixa));
